import { msToAmPmHours, msToPartDayTime } from '~/routes/utils';

const slotsConfig = {
  periods: {
    Morning: {
      from: 9 * 3600 * 1000,
      to: 13 * 3600 * 1000,
    },
    Afternoon: {
      from: 13 * 3600 * 1000,
      to: 17 * 3600 * 1000,
    },
    Evening: {
      from: 17 * 3600 * 1000,
      to: 24 * 3600 * 1000,
    },
  },
};

const timeConfig = {
  Morning: 'between 9am - 1pm',
  Afternoon: 'between 1pm - 5pm',
  Evening: 'after 5pm (varies by shop)',
};

export const formatTimeToDayTime = (time) =>
  Object.entries(slotsConfig.periods).find(([, value]) => time < value.to)[0];

export const formatTimeToPeriod = (startTime) => timeConfig[formatTimeToDayTime(startTime)];

export const groupSlotsByStartTime = (slots, config) =>
  slots.reduce(
    (acc, cur) => {
      if (cur.from >= config.periods.Morning.from && cur.from <= config.periods.Morning.to) {
        return {
          Morning: [...acc.Morning, cur],
          Afternoon: acc.Afternoon,
          Evening: acc.Evening,
        };
      }
      if (cur.from >= config.periods.Afternoon.from && cur.from <= config.periods.Afternoon.to) {
        return {
          Morning: acc.Morning,
          Afternoon: [...acc.Afternoon, cur],
          Evening: acc.Evening,
        };
      }
      if (cur.from >= config.periods.Evening.from && cur.from <= config.periods.Evening.to) {
        return {
          Morning: acc.Morning,
          Afternoon: acc.Afternoon,
          Evening: [...acc.Evening, cur],
        };
      }
      return acc;
    },
    {
      Morning: [],
      Afternoon: [],
      Evening: [],
    },
  );

const convertSlotsToObj = (slots) =>
  slots.reduce(
    (acc, cur) => {
      if (
        cur.from >= slotsConfig.periods.Morning.from &&
        cur.to <= slotsConfig.periods.Morning.to
      ) {
        return {
          Morning: [...acc.Morning, cur],
          Afternoon: acc.Afternoon,
          Evening: acc.Evening,
        };
      }
      if (
        cur.from >= slotsConfig.periods.Afternoon.from &&
        cur.to <= slotsConfig.periods.Afternoon.to
      ) {
        return {
          Morning: acc.Morning,
          Afternoon: [...acc.Afternoon, cur],
          Evening: acc.Evening,
        };
      }
      if (
        cur.from >= slotsConfig.periods.Evening.from &&
        cur.to <= slotsConfig.periods.Evening.to
      ) {
        return {
          Morning: acc.Morning,
          Afternoon: acc.Afternoon,
          Evening: [...acc.Evening, cur],
        };
      }
      return acc;
    },
    {
      Morning: [],
      Afternoon: [],
      Evening: [],
    },
  );

export const formatHomeDesignAtHomeSlots = (slots) =>
  Object.entries(convertSlotsToObj(slots, slotsConfig)).reduce(
    (acc, [key, value]) => (value.length > 0 ? [...acc, { ...value[0], title: key }] : [...acc]),
    [],
  );

export const areSlotsEqual = (first, second) => {
  if (first.from && second.from) {
    return formatTimeToDayTime(first.from) === formatTimeToDayTime(second.from);
  }
  return false;
};

export const formatFittedBedroomsSlots = (slots) =>
  slots.map((slot) => ({
    ...slot,
    title: msToAmPmHours(slot.from),
  }));

export const formatMeasureSlots = (slots) =>
  slots.map((slot) => ({
    ...slot,
    title: msToPartDayTime(slot.from),
  }));

export const areMeasureSlotsEqual = (first, second) => first.from === second.from;
